import { createSlice } from '@reduxjs/toolkit'
import { registerUser, userLogin, userProfile, fetchUserPermission, userChangePassword } from '../auth/authAction'

const initialState = {
  loading: false,
  loggedUserInfo: null,
  profileInfo: null,
  permissionResult: null,
  permission: null,
  userToken: null,
  error: null,
  registerSuccess: false,
  loginSuccess: false,
  success: false,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // ...logout reducer
    logout: (state) => {
      localStorage.removeItem('userToken')
      localStorage.removeItem('tokenExpireDate')
      localStorage.removeItem('user_id')
      localStorage.removeItem('detailId')
      localStorage.removeItem('user_name')
      localStorage.removeItem('user_role')
      state.loading = false
      state.error = null
      state.userToken = null
      state.loggedUserInfo = null
      state.profileInfo = null
      state.loginSuccess = false
      state.registerSuccess = false
      state.permission = null
      state.permissionResult = null
      state.success = false
    },
    setCredentials: (state, { payload }) => {
      state.loggedUserInfo = payload
    },
    setUserToken: (state, action) => {
      state.userToken = action.payload
    },
    clearAlert: (state) => {
      state.error = null
    }
  },
  extraReducers: {
    // register user
    [registerUser.pending]: (state) => {
      state.loading = true
      state.error = null
      state.registerSuccess = false

    },
    [registerUser.fulfilled]: (state, { payload }) => {
      state.loading = false
      if (!payload.requires_verification) {
        state.loggedUserInfo = payload
        state.userToken = payload.access_token
      }
      state.registerSuccess = true
    },
    [registerUser.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = payload
      state.registerSuccess = false

    },
    // login user
    [userLogin.pending]: (state) => {
      state.loading = true
      state.error = null
      state.loginSuccess = false

    },
    [userLogin.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.loggedUserInfo = payload
      state.userToken = payload.access_token
      state.loginSuccess = true
    },
    [userLogin.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = payload
      state.loginSuccess = false

    },
    // User Profile
    [userProfile.pending]: (state) => {
      state.loading = true
      state.error = null
      state.success = false
    },
    [userProfile.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.profileInfo = payload
      state.success = true

    },
    [userProfile.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = payload
      state.success = false
      state.profileInfo = null  // Clear profile info on auth failure
    },

    [fetchUserPermission.pending]: (state) => {
      state.loading = true
      state.error = null
      state.success = false
    },
    [fetchUserPermission.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.permission = payload.data
      state.success = true

    },
    [fetchUserPermission.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = payload
      state.success = false
      state.permission = null
    },

    // Change Password
    [userChangePassword.pending]: (state) => {
      state.loading = true
      state.error = null
      state.success = false
    },
    [userChangePassword.fulfilled]: (state) => {
      state.loading = false
      state.success = true
    },
    [userChangePassword.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = payload
      state.success = false
    }
  },
})
export const { logout, setCredentials, setUserToken, clearAlert } = authSlice.actions
export default authSlice.reducer